export default "__VITE_ASSET__BLdcuX9q__"